import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";

let user = JSON.parse(localStorage.getItem("currentUser"));

export const searchDeviceMgmt = (item) => {
  let url = `${API.SearchDevice}?id=${item.id??''}&Make=${item.make??''}&Model=${item.modal??''}&ManufacturingDateFrom=${item.manufacturingFrom??''}&ManufacturingDateTo=${item.manufacturingTo??''}&LastCalibrationDateFrom=${item.lastCalibrationFrom??''}&LastCalibrationDateTo=${item.lastCalibrationTo??''}&NextCalibrationDateFrom=${item.nextCalibrationFrom??''}&NextCalibrationDateTo=${item.nextCalibrationTo??''}&CompanyName=${item.companyName??''}&ShipName=${item.shipName??''}&PageSize=${item.pageSize??25}&PageNumber=${item.pageNumber??1}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        
        dispatch({
          type: "getSearchDeviceSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getSearchDeviceFailure",
          error: "ERROR",
        });
      });
  };
};

export const getDeviceDetails = (deviceId) => {
  let url = `${API.GetDeviceDetails}?deviceId=${deviceId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getDeviceDetailsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getDeviceDetailsFailure",
          error: "ERROR",
        });
      });
  };
};

export const addDevice = (data) => {
  let url = `${API.PostDevice}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "postAddDeviceSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postAddDeviceFailure",
          error: "ERROR",
        });
      });
  };
};

export const updateDevice = (data) => {
  let url = `${API.UpdateDevice}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "putUpdateDeviceSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "putUpdateDeviceFailure",
          error: "ERROR",
        });
      });
  };
};

export const deleteDevice = (data, searchData) => {
  let url = `${API.UpdateDevice}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        
       dispatch(searchDeviceMgmt(searchData));
        dispatch({
          type: "deleteDeviceSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        swal("Error!", "Something went wrong. Please try again.", "warning");
        dispatch({
          type: "deleteDeviceFailure",
          error: "ERROR",
        });
      });
  };
};

export const getClientShipList = (item) => {
  let url = `${API.ShipDetails}?mail=${user.email}&CompanyName=${item}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        let ShipList=[];
         response.data.data.map((item)=>{
             ShipList.push({
               shipId:item.shipId,
               shipName:item.shipName
             })
         })
      dispatch({
          type: "getClientShipListSuccess",
          data: ShipList,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getClientShipListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getClientShippingCompanyList = (item) => {
  let url = `${API.ShipCompanyList}?mail=${user.email}&CompanyName=${item}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        let ShipList=[];
         response.data.map((item)=>{
             ShipList.push({
               shipId:item.shipId,
               shipName:item.shipName
             })
         })
      dispatch({
          type: "getClientShippingCompanyListSuccess",
          data: ShipList,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getClientShippingCompanyListFailure",
          error: "ERROR",
        });
      });
  };
};